import React, {useState} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import * as gtag from '../../cookie/lib/gtag';

const LoanDetails = (props) => {
    const {show, handleClose, details, currency, applyParams, type } = props;

    let provider  = details.showLogo ? 
                    <Image 
                        src={details.providerLogo} 
                        height={details.logoSize.height} 
                        width={details.logoSize.width}
                    /> 
                    :
                    <p>{details.provider}</p>;

    let apr = details.interestScheme == 'dobanda_unica' ?
                <>{Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)}%</>
               :
                <span>între {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)} - {details.aprMax}</span>;

    let totalCost = details.interestScheme == 'dobanda_unica' ?
                <>{Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)} {currency}</>
                :
                <span>între {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)} - {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmountMax)} {currency}</span>;

    let installment = details.interestScheme == 'dobanda_unica' ?
                <>{Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.monthlyPayment)} {currency}</>
                :
                <span>între {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.monthlyPayment)} - {details.monthlyPaymentMax} {currency}</span>;


    let interestRate, margin;
    if (details.interestScheme == 'dobanda_unica') {
       interestRate = <span>{details.minInterestRate}</span>;
       if (details.rateType !== 'fixa') {
            margin = <span>{details.referenceRate} + {details.minMargin}</span>;
       } 
      
    } else {
        interestRate = <span>intre {details.minInterestRate} si {details.maxInterestRate}</span>;
        if (details.rateType !== 'fixa') {
            margin = <span>{details.referenceRate} + {details.minMargin} / {details.maxMargin}</span>;
       }
    }

    let rate = details.interestScheme == 'dobanda_unica' ?
                details.monthlyPayment :
                <span>între {details.monthlyPayment} - {details.monthlyPaymentMax}</span>;
    
    let riskFee = details.hasOwnProperty('riskFee')  && 
                <>
                    <Col xs="12" md="5" className={styles.key}>
                    Comision de risc
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.riskFee}
                    </Col>
                </>;
    let guaranteeFee = details.hasOwnProperty('stateGuarantee')  && 
                <>
                    <Col xs="12" md="5" className={styles.key}>
                    Comision de garantare
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.stateGuarantee}
                    </Col>
                </>;

    let relOpennerTag;
    if (details.hasOwnProperty('apply')) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else if (details.hasOwnProperty('webLink')){
        relOpennerTag = details.webLink.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } {
        relOpennerTag = '';
    }

    const onApply = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) {
           gtag.event('Apply', {
                provider: details.provider,
                product: type,
            });
        } else {
            console.log("beta");
        }
        handleClose();
     }
    

  
    return (
        <Modal show={show} onHide={handleClose} dialogClassName={styles.modal90w}>
            <Modal.Header closeButton>
                <Modal.Title>             
                    {provider}
                    <p className={`${styles.productName} text-muted mb-0`}>{details.product}</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                                `${details.apply}${applyParams ? '?'+ applyParams : ''}`
                                : 
                                details.apply
                                }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 
                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Cost total
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        DAE
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {apr}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Suma de rambursat
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {totalCost}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Prima rată lunară
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {installment}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Costuri la acordarea creditului
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.upfrontFees}
                    </Col>
                </Row>
                <Row className={styles.endSection}>                   
                    <Col xs="12" className={styles.productSection}>
                        Dobânda
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Rata dobânzii
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {interestRate}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Tip dobândă
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.rateType}
                    </Col>
                    { margin &&
                        <> 
                            <Col xs="12" md="5" className={styles.key}>
                                Formula de calcul
                            </Col>
                            <Col xs="12" md="7" className={styles.info}>
                                {margin}
                            </Col>
                        </>
                    }
                    { details.specialTerms &&
                        <> 
                            <Col xs="12" md="5" className={styles.key}>
                                Condiții speciale
                            </Col>
                            <Col xs="12" md="7" className={styles.info}>
                                {details.specialTerms}
                            </Col>
                        </>
                    }

                </Row>
                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Comisioane
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Comision de analiză
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.applicationFee}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Comision de administrare
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.managementFee}
                    </Col>
                    {riskFee}
                    {guaranteeFee}
                    <Col xs="12" md="5" className={styles.key}>
                       Rambursare anticipată
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.earlyRepaymentFee}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Comision unic
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.uniqueFee}
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" className={styles.productSection}>
                        Asigurări
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Asigurare de viață
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.lifeInsurance ? details.lifeInsurance : '-'}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Asigurare de imobil
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.houseInsurance ? details.houseInsurance : '-' }
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Alte asigurări obligatorii
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.otherInsurance ? details.otherInsurance : '-' }
                    </Col>
                    
                </Row>
                <Row>
                    <Col xs="12" className={styles.productSection}>
                        Alte condiții
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Venit minim (estimari Conso)
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.requiredIncome} RON
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Virare venit la bancă
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.widthIncome ? 'da' : 'nu'}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Avans minim
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.minDownpayment}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                       Perioada de grație
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.gracePeriod}
                    </Col>

                </Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-between" >  
                {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                            `${details.apply}${applyParams ? '?'+ applyParams : ''}`
                            : 
                            details.apply
                        }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 
                
                <Button variant="outline-secondary" onClick={handleClose}>
                    Închide
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LoanDetails;